
import React, {useState, useEffect} from 'react';

import { useParams, Link, useSearchParams, useNavigate} from "react-router-dom";
import $ from 'jquery';

import GLOBALS from '../elements/Globals';
import Loader from '../elements/Loader';

const createMarkup = (htmlString) => {
  return { __html: htmlString };
};

const Search = (props) => {

  const [loading, setLoading] = useState(false);
  const [searchheadline, setSearchheadline ]= useState([]);
  const [searchheadlineData, setSearchheadlineData ]= useState([]);
  const [pages, setPages ]= useState([]);
  let [searchParams, setSearchParams] = useSearchParams();
  let keyword = searchParams.get("keyword");
  let p = searchParams.get("p");
  let [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

   useEffect(() => {
      setLoading(true)
      
      async function getDataBoxingNews() {
        let apiUrl = 'search?title='+keyword+'&p='+p;
        const url = GLOBALS.API_BASE_URL+apiUrl;
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
          }
          const json = await response.json();
          setSearchheadline(json);
          setSearchheadlineData(json.data);
          setPages(json.pages)
          setLoading(false)
          setCurrentPage(json.currentPage)
        } catch (error) {
          console.error(error.message);
        }
      }
      getDataBoxingNews();

      return () => {
        // Cleanup logic here
      };
    }, [keyword, p]);
  
    const handleSubmit = (event) => {
      event.preventDefault();
      navigate('/search?keyword='+event.target.keyword.value+'&p=1');
      $('#mySidenav').hide()
      $('body').css('overflow','auto')
      // Handle form data and navigation here
    };
  
  return (
   
  <div className="mvpBgContainer mvp_container" id="newsMainContent">
  <div className="service_content contentShadow searchResultContainer" style={{minHeight: 219}}>
    <div className="search_page_form container-fluid px-3" itemScope itemType="https://schema.org/WebSite">
      <meta itemProp="url" content="https://www.mvpboxing.com/" />
      <div className="pagination_options container-fluid pt-3 px-3 resultsfor">
      <div className="left srch_pagination">
        <div className="searchLabel">Search Results</div>
      </div>
      <div className="clear" />
    </div>
      <div className="left srchForm">
        <form onSubmit={handleSubmit} method="get" id="mainsearch_page_form" style={{position: 'relative'}} itemProp="potentialAction" itemScope itemType="https://schema.org/SearchAction">
          <meta itemProp="target"/>
          <div className="input-group search-div">
            <input type="text" className="form-control search-input cis" placeholder="Search..." id="keyword" name="keyword" itemProp="query-input" defaultValue={searchheadline.searhTerm} />
            <div className="input-group-append">
              <button className="btn search-btn" name="search_submit" type="submit">
                <i className="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div className="clear" />
        </form>
      </div>
      <div className="clear" />
    </div>
    <Loader loading={loading} />
    <div id="searchListings">
      {
        searchheadlineData.map((item, i)=> {
          return(
            <div className="srch_list">
              <div className="left listContent">
                <div className="listContentTitle"><Link to={item.id} title="podcasts mma">{item.title}</Link></div>
                <div className="listContentTime" />
                <div className="listShortText">
                </div>
              </div>
            <div className="clear" />
           <div className="listSeparator" />
      </div>
          )
        })
      }
    </div>
    <div className="pagination_options container-fluid px-3">
      <div className="left srch_pagination">
        <div className="srchResInfo">Results &nbsp;
            <label> {searchheadline.current_interval}</label> of &nbsp; 
            <label> {searchheadline.totalCnt}</label>
        </div>
        <div className="srchResInfo">{/*<span>“{searchheadline.searhTerm}”</span> Results*/}
          {/*<label>{searchheadline.current_interval}</label> of
          <label>{searchheadline.totalCnt}</label>*/}
        </div>
        <p>
          {
            p > 1 ? (
            <span>
              <Link to={"/search?keyword="+keyword+"&p="+(parseInt(p)-1)} data-ci-pagination-page="4" rel="prev">&lt;</Link>
            </span>
            ):("")
          }
          
        {pages.map((item, i) => {
          return (
            <Link to={"/search?keyword="+keyword+"&p="+(parseInt(item.number))} className={item.active == 1 ? ("page-active"):("")} id="home_1">{item.number}</Link>
          )
        })}
        
        {
            parseInt(searchheadline.totalPageCnt) == parseInt(searchheadline.totalPageCnt) ? (
            <span>
              <Link to={"/search?keyword="+keyword+"&p="+(parseInt(p)+1)} data-ci-pagination-page={2} rel="next">&gt;</Link>
            </span>
            ):("")
          }

        </p>       
      </div>
      <div className="clear" />
    </div>
  </div>
</div>


  )
};

export default Search;